import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlaceName = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['name'] => getPlace(placeKey)(store).name;
